import { Mode } from "~/types";
import { FONTS } from "~/data/partner_config";

export function classNames(
  ...classNames: (string | null | undefined)[]
): string {
  return classNames.filter((value) => value).join(" ");
}

export function getHexColorBrightness(color: string) {
  const r = parseInt(color.slice(1, 3), 16);
  const g = parseInt(color.slice(3, 5), 16);
  const b = parseInt(color.slice(5, 7), 16);

  return (r * 299 + g * 587 + b * 114) / 1000;
}

export const getFonts = (mode?: Mode, clientIdPrefix?: string): string[] => {
  if (mode === "rnr") {
    return [...FONTS.rnr];
  }
  return FONTS.default;
};

export function getPrefixFromClientId(clientId: string): string {
  const parts = clientId.split("-");
  return parts.slice(0, -1).join("-") || parts[0];
}
